/**
 * Slideshow Stones Custom Navigation
 * Handles thumbnail navigation and arrow buttons for slideshow-stones section
 */

document.addEventListener('DOMContentLoaded', function() {
  const slideshowStones = document.querySelectorAll('.section-slideshow-stones');
  
  slideshowStones.forEach(function(section) {
    const contentSlideshow = section.querySelector('.image-with-text-slideshow__content');
    const imageSlideshow = section.querySelector('.image-with-text-slideshow__image');
    const thumbnails = section.querySelectorAll('.thumbnail-item');
    const prevButton = section.querySelector('.flickity-prev');
    const nextButton = section.querySelector('.flickity-next');
    
    if (!contentSlideshow || thumbnails.length === 0) return;
    
    // Wait for Flickity to be initialized
    const checkFlickity = setInterval(function() {
      if (contentSlideshow.flickityGUID && window.Flickity) {
        clearInterval(checkFlickity);
        initializeCustomNavigation();
      }
    }, 100);
    
    function initializeCustomNavigation() {
      const flkty = contentSlideshow.flickityGUID ? window.Flickity.data(contentSlideshow) : null;
      
      if (!flkty) return;
      
      // Handle thumbnail clicks
      thumbnails.forEach(function(thumbnail, index) {
        thumbnail.addEventListener('click', function() {
          flkty.select(index);
        });
        
        // Add keyboard support
        thumbnail.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            flkty.select(index);
          }
        });
      });
      
      // Handle arrow button clicks
      if (prevButton) {
        prevButton.addEventListener('click', function() {
          flkty.previous();
        });
      }
      
      if (nextButton) {
        nextButton.addEventListener('click', function() {
          flkty.next();
        });
      }
      
      // Update thumbnail states when slide changes
      flkty.on('change', function(index) {
        updateThumbnailStates(index);
      });
      
      // Initial state
      updateThumbnailStates(flkty.selectedIndex);
    }
    
    function updateThumbnailStates(activeIndex) {
      thumbnails.forEach(function(thumbnail, index) {
        if (index === activeIndex) {
          thumbnail.classList.add('is-selected');
          thumbnail.setAttribute('aria-current', 'true');
        } else {
          thumbnail.classList.remove('is-selected');
          thumbnail.removeAttribute('aria-current');
        }
      });
    }
  });
});
